import { StackLayout, Box } from '@leagueplatform/genesis-core';
import { Masonry } from '@leagueplatform/masonry';

export const PremiumPaymentHistoryMasonrySection = () => (
  <StackLayout
    orientation="vertical"
    css={{
      marginBottom: '$three',
    }}
  >
    <Box style={{ width: '100%' }}>
      <Masonry rootNodeId="premium-payment-history$root" />
    </Box>
  </StackLayout>
);
